import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import cn from 'classnames';
import styles from './index.module.less'
import ReviewDetail from '../ReviewDetail'
import { IFeatureSwiperReviews } from 'mod/feature/interface'

type IProps = {
    visible: boolean;
    onClose?: () => void;
    onCloseModal?: () => void;
    reviewItem?: IFeatureSwiperReviews['lists'][number]
}

const ReviewDetailModal: React.FC<IProps> = (props) => {
    const { visible, onClose, onCloseModal, reviewItem } = props;

    return(
        <Modal
            className={cn(styles.modal)}
            destroyOnClose={true}
            width={720}
            open={visible}
            onCancel={onClose||onCloseModal}
            footer={false}
            centered
        >
            <ReviewDetail reviewItem={reviewItem}/>
        </Modal>
    );
};

export default ReviewDetailModal